<ng-container *ngIf="target">
  <a type="button" class="btn btn-primary" [routerLink]="route">
    <i class="ft-plus-circle mr-1"></i>
    <span translate>Add</span>
  </a>
</ng-container>
